import React, { useState } from "react";
import { Dialog, DialogFooter } from "../../components/ui/Dialog";
import { Button } from "../../components/ui/Button";
import { createSchemeBucket } from "../../services/schemeBucket";

interface AddBucketDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onAdded?: () => void;
}

const AddBucketDialog: React.FC<AddBucketDialogProps> = ({
  isOpen,
  onClose,
  onAdded,
}) => {
  const [name, setName] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(""); // For showing error below input

  const handleAdd = async () => {
    if (!name.trim()) {
      setError("Please enter scheme bucket name.");
      return;
    }

    setLoading(true);
    setError(""); // Clear previous error
    try {
      await createSchemeBucket({ name: name.trim() });
      onAdded?.();

      // Reset form fields
      setName("");
      onClose();
    } catch (err) {
      const message = (err as Error).message || "Failed to add bucket";
      setError(message); // Show error below input
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog
      isOpen={isOpen}
      onClose={onClose}
      title="Add Scheme Bucket"
      size="md"
      footer={
        <DialogFooter>
          <Button onClick={onClose} variant="outline">
            Cancel
          </Button>
          <Button onClick={handleAdd} disabled={loading}>
            {loading ? "Adding..." : "Add"}
          </Button>
        </DialogFooter>
      }
    >
      <div>
        <label className="block text-sm font-medium mb-1">Name</label>
        <input
          type="text"
          value={name}
          onChange={(e) => setName(e.target.value)}
          className={`w-full px-2 py-1 border rounded ${
            error ? "border-red-500" : "border-gray-300"
          }`}
        />
        {error && <p className="text-red-500 text-sm mt-1">{error}</p>}
      </div>
    </Dialog>
  );
};

export default AddBucketDialog;
